import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';

/** Fetch a single addressable event (newest version) by coordinate parts. */
export function useAddressableEvent(kind: number, pubkey: string, identifier: string) {
  const { nostr } = useNostr();
  const valid = kind > 0 && /^[0-9a-f]{64}$/i.test(pubkey);

  return useQuery({
    queryKey: ['nostr', 'addressable-event', kind, pubkey, identifier],
    queryFn: async () => {
      const events = await nostr.query(
        [{ kinds: [kind], authors: [pubkey], '#d': [identifier], limit: 1 }],
        { signal: AbortSignal.timeout(6000) },
      );
      return events[0] ?? null;
    },
    enabled: valid,
  });
}

/** Fetch a single event by id. */
export function useEventById(id: string) {
  const { nostr } = useNostr();
  const valid = /^[0-9a-f]{64}$/i.test(id);

  return useQuery({
    queryKey: ['nostr', 'event-by-id', id],
    queryFn: async () => {
      const events = await nostr.query(
        [{ ids: [id], limit: 1 }],
        { signal: AbortSignal.timeout(6000) },
      );
      return events[0] ?? null;
    },
    enabled: valid,
  });
}
